import React, { useCallback, useMemo } from 'react';

import { formatPrice } from 'js/components/shared/vehicleFunctions';
import Traductor from 'components/Traductor';

import Button from 'components/bronson/Button';

const BidAmounts = ({ vehicle, padding, disabled, loading, onBid }) => {
    const t = useMemo(() => new Traductor(), []);

    const printYourMaxBid = useCallback(() => {
        let status = '';
        if (vehicle.Status === 2) {
            if (vehicle.maxBidAWStatus === 1) {
                status = ' c-vehicle-buy-options__bid-price--green';
            } else if (vehicle.maxBidAWStatus === 2) {
                status = ' c-vehicle-buy-options__bid-price--red';
            }
        }
        return (
            <div className={'o-layout__item u-1/3 ' + padding + ' u-pr-none'}>
                <p className="rema-text-overflow--ellipsis u-mb-xsmall">
                    {t.getTraduction('YourMaximumBid')}
                </p>
                <p
                    className={
                        'u-h6 c-vehicle-buy-options__bid-price ' + status
                    }
                >
                    {vehicle.UserAmountBidMaxAWS
                        ? formatPrice(vehicle.UserAmountBidMaxAWS)
                        : '--'}
                </p>
            </div>
        );
    }, [
        padding,
        t,
        vehicle.Status,
        vehicle.UserAmountBidMaxAWS,
        vehicle.maxBidAWStatus,
    ]);

    const printActualBid = useCallback(() => {
        const label = vehicle.AmountAWS
            ? t.getTraduction('CurrentBid')
            : t.getTraduction('InitialBid');
        return (
            <div className="o-layout__item u-1/3">
                <p className="rema-text-overflow--ellipsis u-mb-xsmall">
                    {label}
                </p>
                <p className={'u-h6 c-vehicle-buy-options__bid-price '}>
                    {vehicle.AmountAWS
                        ? formatPrice(vehicle.AmountAWS)
                        : formatPrice(vehicle.MinimumPrice)}
                </p>
            </div>
        );
    }, [t, vehicle.AmountAWS, vehicle.MinimumPrice]);

    const printActualBidButton = useCallback(() => {
        const optionsBtnPujaRapida = {
            class: 'c-btn--full c-btn--primary-b u-mt-small',
            text: !vehicle.AmountAWS
                ? t.getTraduction('InitialBid')
                : '+' + vehicle.DifferentialAmount + '€',
            btnTypes: ['secondary'],
            disabled:
                loading ||
                disabled ||
                vehicle.UserAmountBidMaxAWS > vehicle.AmountAWS,
        };

        return (
            <div className={'o-layout__item u-1/3 u-p-none'}>
                <Button
                    options={optionsBtnPujaRapida}
                    onClick={() => onBid('button')}
                />
            </div>
        );
    }, [
        disabled,
        loading,
        onBid,
        t,
        vehicle.AmountAWS,
        vehicle.DifferentialAmount,
        vehicle.UserAmountBidMaxAWS,
    ]);

    return (
        <div className="o-layout">
            {printYourMaxBid()}
            {printActualBid()}
            {printActualBidButton()}
        </div>
    );
};

export default BidAmounts;
